/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type CancelLeaveResponse = {
  success: boolean;
  message?: string;
  data?: any;
};

export const cancelLeaveRequest = async (
  id: string
): Promise<CancelLeaveResponse> =>
  (
    await customAxios.delete<CancelLeaveResponse>(
      `/leaves/cancel-leave-request/${id}`
    )
  ).data;

export const useCancelLeaveRequest = () => {
  const queryClient = useQueryClient();

  return useMutation<CancelLeaveResponse, AxiosError, string>(
    cancelLeaveRequest,
    {
      onSuccess: (res) => {
        showNotification({
          title: "Leave Cancelled",
          message: res.message ?? "Leave request cancelled successfully.",
          color: "green",
        });

        queryClient.invalidateQueries(["leaves", "requests"]);
        queryClient.invalidateQueries(["leaves", "balance"]);
      },
      onError: (error) => {
        showNotification({
          title: "Error Cancelling Leave",
          message:
            (error.response?.data as { message?: string })?.message ??
            error.message ??
            "Failed to cancel leave request",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
